<script>
import model from "@/mixins/model";

/**
 * @component TaskNotification
 * @description Configuración de notificaciones de la tarea: push al paciente
 *              (si la tarea es periodizada) y alertas en el dashboard del médico.
 *              Layout v3: label-izquierda + field-derecha, switches en vez de
 *              checkboxes.
 * @prop {Boolean} showPeriodization - Si la tarea tiene periodización (controla
 *                                     visibilidad del switch de push).
 */
export default {
  name: "TaskNotification",

  mixins: [model],

  props: {
    showPeriodization: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template lang="pug">
.modal__block
  .modal__section
    h3.section-title Notificaciones

    .nt
      .nt-row(v-if="showPeriodization")
        .nt-row__label
          span Push al paciente
          .nt-row__hint Se envía en cada horario configurado en periodización
        .nt-row__field
          el-switch(v-model="model.shouldNotify")

      .nt-row
        .nt-row__label
          span Alertas en dashboard
          .nt-row__hint Mostrar alerta al médico cuando la tarea requiera atención
        .nt-row__field
          el-switch(v-model="model.shouldAlert")
</template>

<style lang="scss" scoped>
$row-label-width: 200px;
$text-soft: #6b7592;
$text-mute: #a6adbf;

.nt {
  max-width: 760px;
}

.nt-row {
  display: grid;
  grid-template-columns: $row-label-width 1fr;
  gap: 24px;
  align-items: center;
  padding: 12px 0;
}

.nt-row__label {
  font-size: 13px;
  font-weight: 500;
  color: $text-soft;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nt-row__hint {
  font-size: 12px;
  color: $text-mute;
  font-weight: 400;
}

.nt-row__field ::v-deep .el-switch__core {
  border-color: #d0d6e2;
}
</style>
